<template>
    <div class="body">
        <div class="cardHead">
            <span class="cardA">
                <p class="cardP">
                    <span class="cardTitle">
                        <img class="cardImg" src="https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/qiouou-cms/summer/cardAdd.png"/>
                    </span>
                    <span class="cardContent">录入收据</span>
                </p>
                <p class="cardP">
                    <span class="cardTitle">区间:</span>
                    <span class="cardContent"><el-input class="cardInput"  v-model="cardAdd.startNum" placeholder="起始编号">--</el-input>-<el-input class="cardInput" v-model="cardAdd.endNum"  placeholder="结束编号"></el-input></span>
                </p>
                 <p class="cardP">
                    <span class="cardTitle"></span>
                    <span class="cardContent">
                        <!-- <el-select v-model="cardAdd.vipType" class="cardSelect" placeholder="请选择">
                            <el-option v-for="item in vipList"  :key="item.value"  :label="item.label"  :value="item.value"></el-option>
                        </el-select> -->
                    </span>
                </p>
                <el-button class="cardButton" size="small" type="primary" @click="sendAdd">确定录入</el-button>
            </span>

            <span class="card">
                <p class="cardP">
                    <span class="cardTitle">
                        <img class="cardImg" src="https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/qiouou-cms/summer/cardGrant.png"/>
                    </span>
                    <span class="cardContent">发放收据</span>
                </p>
                <p class="cardP">
                    <span class="cardTitle">区间:</span>
                    <span class="cardContent"><el-input class="cardInput" v-model="cardGrant.startNum" placeholder="起始编号">--</el-input>-<el-input class="cardInput" v-model="cardGrant.endNum"  placeholder="结束编号"></el-input></span>
                </p>
                 <p class="cardP">
                    <span class="cardTitle">员工账号:</span>
                    <span class="cardContent"><el-input v-model="cardGrant.telNumber"  placeholder="请输入小鸥管家登陆账号"></el-input></span>
                </p>
                <el-button class="cardButton" type="success" size="small" @click="sendGrant">确定发放</el-button>
            </span>

            <span class="card">
                <p class="cardP">
                    <span class="cardTitle">
                        <img class="cardImg" src="https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/qiouou-cms/summer/cardDelete.png"/>
                    </span>
                    <span class="cardContent">回收收据</span>
                </p>
                <p class="cardP">
                    <span class="cardTitle">区间:</span>
                    <span class="cardContent"><el-input class="cardInput"  v-model="cardRecycle.startNum" placeholder="起始编号">--</el-input>-<el-input class="cardInput"  v-model="cardRecycle.endNum" placeholder="结束编号"></el-input></span>
                </p>
                 <p class="cardP">
                    <span class="cardTitle"></span>
                    <span class="cardContent"></span>
                </p>
                <el-button class="cardButton" size="small" type="warning" @click="sendRecycle">确定回收</el-button>
            </span>

            <span class="card">
                <p class="cardP">
                    <span class="cardTitle">
                        <img class="cardImg" src="https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/qiouou-cms/summer/cardRecycle.png"/>
                    </span>
                    <span class="cardContent">删除收据</span>
                </p>
                <p class="cardP">
                    <span class="cardTitle">区间:</span>
                    <span class="cardContent"><el-input class="cardInput"  v-model="cardDelete.startNum" placeholder="起始编号">--</el-input>-<el-input  v-model="cardDelete.endNum" class="cardInput" placeholder="结束编号"></el-input></span>
                </p>
                 <p class="cardP">
                    <span class="cardTitle"></span>
                    <span class="cardContent"></span>
                </p>
                <el-button class="cardButton" size="small" type="danger" @click="sendDelete">确定删除</el-button>
            </span>
        </div>
        <div class="table">

                <div class="inv-h-w">
                    <div :class="['inv-h',Inv==1?'inv-h-se':'']" @click="speed(1)">录入记录</div>
                    <div :class="['inv-h',Inv==2?'inv-h-se':'']" @click="speed(2)">发放记录</div>
                    <div :class="['inv-h',Inv==3?'inv-h-se':'']" @click="speed(3)">回收记录</div>
                    <div :class="['inv-h',Inv==4?'inv-h-se':'']" @click="speed(4)">删除记录</div>
                </div>

                <div v-show="Inv == 1">
                    <div class="title">
                        <span class="search">
                            <el-input class="searchInput" v-model="page.condition.key"  @change="search" placeholder="姓名/手机号"></el-input>
                        </span>
                        <span class="sortA">
                            <el-date-picker  v-model="time" value-format="yyyy-MM-dd" type="daterange" range-separator="-"  start-placeholder="开始日期" end-placeholder="结束日期" @change="timeSection"></el-date-picker>
                        </span>
                        <!-- <span class="sortB"> -->
                        <!-- <el-select v-model="page.condition.type" placeholder="请选择"> -->
                                <!-- <el-option  v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option> -->
                            <!-- </el-select> -->
                        <!-- </span> -->
                        <span class="sortC">
                            <el-button type="primary" @click="search">查询</el-button>
                            <el-button plain @click="reset">重置</el-button>
                        </span>
                    </div>
                    <!-- <p class="tableFiltrate">
                        
                    </p> -->
                    <div class="tableList">
                        <el-table  :data="list" :header-cell-style="tableHeaderColor" v-loading="loading"  style="width: 100%">
                            <el-table-column prop="startNum"  label="起始编号"></el-table-column>
                            <el-table-column  prop="endNum" label="结束编号"></el-table-column>
                            <el-table-column prop="entryName" label="录入人"></el-table-column>
                            <el-table-column prop="entryDt" label="录入时间"></el-table-column>
                            <el-table-column prop="entryDt" label="操作">
                                <template slot-scope="scope">
                                    <el-button type="primary" @click.native.prevent="listInfo(scope.row)">发放明细</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <p class="customPage"><span ><el-pagination  background layout="prev, pager, next" @current-change="handleCurrentChange" :current-page="page.current" :page-size="page.size"  :total="total"></el-pagination></span></p>
                    </div>
                </div>


                <div v-show="Inv == 2">
                    <div class="title">
                        <span class="search">
                            <el-input class="searchInput" v-model="page.condition.key"  @change="search" placeholder="姓名/手机号"></el-input>
                        </span>
                        <span class="sortA">
                            <el-date-picker  v-model="time" value-format="yyyy-MM-dd" type="daterange" range-separator="-"  start-placeholder="开始日期" end-placeholder="结束日期" @change="timeSection"></el-date-picker>
                        </span>
                        <!-- <span class="sortB">
                        <el-select v-model="page.condition.type" placeholder="请选择">
                                <el-option  v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </span> -->
                        <span class="sortC">
                            <el-button type="primary" @click="search">查询</el-button>
                            <el-button plain @click="reset">重置</el-button>
                        </span>
                    </div>
                    <!-- <p class="tableFiltrate">
                        
                    </p> -->
                    <div class="tableList">
                        <el-table  :data="list" :header-cell-style="tableHeaderColor" v-loading="loading"  style="width: 100%">
                            <el-table-column prop="startNum"  label="起始编号"  width="180"></el-table-column>
                            <el-table-column  prop="endNum" label="结束编号" width="180"></el-table-column>
                            <el-table-column prop="staffName" label="员工"></el-table-column>
                            <el-table-column prop="staffCode" label="工号"></el-table-column>
                            <el-table-column prop="entryDt" label="操作时间"></el-table-column>
                        </el-table>
                        <p class="customPage"><span ><el-pagination  background layout="prev, pager, next" @current-change="handleCurrentChange" :current-page="page.current" :page-size="page.size"  :total="total"></el-pagination></span></p>
                    </div>
                </div>

                <div v-show="Inv == 3">
                    <div class="title">
                        <span class="search">
                            <el-input class="searchInput" v-model="page.condition.key"  @change="search" placeholder="姓名/手机号"></el-input>
                        </span>
                        <span class="sortA">
                            <el-date-picker  v-model="time" value-format="yyyy-MM-dd" type="daterange" range-separator="-"  start-placeholder="开始日期" end-placeholder="结束日期" @change="timeSection"></el-date-picker>
                        </span>
                        <!-- <span class="sortB">
                        <el-select v-model="page.condition.type" placeholder="请选择">
                                <el-option  v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </span> -->
                        <span class="sortC">
                            <el-button type="primary" @click="search">查询</el-button>
                            <el-button plain @click="reset">重置</el-button>
                        </span>
                    </div>
                    <!-- <p class="tableFiltrate">
                        
                    </p> -->
                    <div class="tableList">
                        <el-table  :data="list" :header-cell-style="tableHeaderColor" v-loading="loading"  style="width: 100%">
                            <el-table-column prop="startNum"  label="起始编号"  width="180"></el-table-column>
                            <el-table-column  prop="endNum" label="结束编号" width="180"></el-table-column>
                            <el-table-column prop="entryName" label="操作人"></el-table-column>
                            <el-table-column prop="entryDt" label="操作时间"></el-table-column>
                        </el-table>
                        <p class="customPage"><span ><el-pagination  background layout="prev, pager, next" @current-change="handleCurrentChange" :current-page="page.current" :page-size="page.size"  :total="total"></el-pagination></span></p>
                    </div>
                </div>


                <div v-show="Inv == 4">
                    <div class="title">
                        <span class="search">
                            <el-input class="searchInput" v-model="page.condition.key"  @change="search" placeholder="姓名/手机号"></el-input>
                        </span>
                        <span class="sortA">
                            <el-date-picker  v-model="time" value-format="yyyy-MM-dd" type="daterange" range-separator="-"  start-placeholder="开始日期" end-placeholder="结束日期" @change="timeSection"></el-date-picker>
                        </span>
                        <!-- <span class="sortB">
                        <el-select v-model="page.condition.type" placeholder="请选择">
                                <el-option  v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </span> -->
                        <span class="sortC">
                            <el-button type="primary" @click="search">查询</el-button>
                            <el-button plain @click="reset">重置</el-button>
                        </span>
                    </div>
                    <!-- <p class="tableFiltrate">
                        
                    </p> -->
                    <div class="tableList">
                        <el-table  :data="list" :header-cell-style="tableHeaderColor" v-loading="loading"  style="width: 100%">
                            <el-table-column prop="startNum"  label="起始编号"  width="180"></el-table-column>
                            <el-table-column  prop="endNum" label="结束编号" width="180"></el-table-column>
                            <el-table-column prop="entryName" label="操作人"></el-table-column>
                            <el-table-column prop="entryDt" label="操作时间"></el-table-column>
                        </el-table>
                        <p class="customPage"><span ><el-pagination  background layout="prev, pager, next" @current-change="handleCurrentChange" :current-page="page.current" :page-size="page.size"  :total="total"></el-pagination></span></p>
                    </div>
                </div>
                
               
                
        </div>
        <!-- 会员卡 -->
    </div>
</template>

<script>
    export default {
      data() {
        return {    
          Inv:1,
          page:{
                condition:{
                    key:null,
                    type:null,

                    datumStatus:null,
                    source:null,
                    startDt:null,
                    endDt:null,
                    departmentKey:null,
                    startNum:null,
                    endNum:null,
                },
                current:1,
                size:6,
                sorts:[
                    {
                        sortColumn:'id',
                        sortType:'DESC',
                    }
                ]
            },
            list:[],
            total:null,
            time: '',
            loading:true,
            options: [
                {value: '1',label: '录入会员卡'},
                {value: '2',label: '发放会员卡'}, 
                {value: '3',label: '回收会员卡'}, 
                {value: '4',label: '删除会员卡'}
            ],
            vipList:[],
            cardAdd:{
                startNum:null,
                endNum:null,
            },
            cardGrant:{
                startNum:null,
                endNum:null,
                staffCode:null,
                telNumber:null,
                vipType:null,
            },
            cardRecycle:{
                startNum:null,
                endNum:null,
            },
            cardDelete:{
                startNum:null,
                endNum:null,
            }
        
        }
      },
      mounted(){
          this.cardList()
          this.getVipType()
      },
      methods:{

          //切换
            speed(type){
                this.Inv = type
                this.page.condition.type = type
                this.page.condition.key = null
                this.page.condition.startNum = null
                this.page.condition.endNum = null
                this.cardList()
            },

            //区间明细
            listInfo(row){
                console.log(row)
                this.page.condition.startNum = row.startNum
                this.page.condition.endNum = row.endNum
                this.Inv = 2
                this.page.condition.type = 2
                this.cardList()
            },

            //会员卡列表
            getVipType(){
                this.joker.grant.getVipType().then(res=>{
                    console.log(res)
                    this.vipList = res.content
                })
            },

            //录入会员卡
            sendAdd(){
                if(this.cardAdd.startNum!=null){
                    if((this.cardAdd.endNum!=null && parseInt(this.cardAdd.endNum)>parseInt(this.cardAdd.startNum))|| this.cardAdd.endNum==null){
                        this.joker.grant.receiptAdd(this.cardAdd).then(res=>{
                            console.log(res)
                            if(res.success){
                                alert('录入成功！')
                                this.Inv = 1
                                this.page.condition.type = 1
                                this.cardList()
                            }
                        })
                    }else{
                        alert("结束值不能大于起始值")
                    }
                }else{
                    alert("填写异常")
                }
            },

            //发放会员卡
            sendGrant(){
                if(this.cardGrant.startNum!=null  && this.cardGrant.telNumber!=null){
                    if((this.cardGrant.endNum!=null && parseInt(this.cardGrant.endNum)>parseInt(this.cardGrant.startNum))|| this.cardGrant.endNum==null){
                        this.joker.grant.receiptGrant(this.cardGrant).then(res=>{
                            console.log(res)
                            if(res.success){
                            alert('发放成功！')
                            this.Inv = 2
                            this.page.condition.type = 2
                            this.cardList()
                            }
                            
                        })
                    }else{
                        alert("结束值不能大于起始值")
                    }
                }else{
                    alert("填写异常")
                }
            },

            //回收会员卡
            sendRecycle(){
                if(this.cardRecycle.startNum!=null){
                    if((this.cardRecycle.endNum!=null && parseInt(this.cardRecycle.endNum)>parseInt(this.cardRecycle.startNum))|| this.cardRecycle.endNum==null){
                        this.joker.grant.receiptRecycle(this.cardRecycle).then(res=>{
                            console.log(res)
                            if(res.success){
                            alert('回收成功！')
                            this.Inv = 3
                            this.page.condition.type = 3
                            this.cardList()
                            }
                        })
                    }else{
                        alert("结束值不能大于起始值")
                    }
                }else{
                    alert("填写异常")
                }
            },
            //删除会员卡
            sendDelete(){
                if(this.cardDelete.startNum!=null){
                    if((this.cardDelete.endNum!=null && parseInt(this.cardDelete.endNum)>parseInt(this.cardDelete.startNum))|| this.cardDelete.endNum==null){
                        this.joker.grant.receiptDelete(this.cardDelete).then(res=>{
                            console.log(res)
                            if(res.success){
                            alert('删除成功')
                            this.Inv = 4
                            this.page.condition.type = 4
                            this.cardList()
                            }
                        })
                    }else{
                        alert("结束值不能大于起始值")
                    }
                }else{
                    alert("填写异常")
                }
            },

            //分页
            cardList(){
                this.loading = true
                this.joker.grant.receiptList(this.page).then(res=>{
                    console.log(res)
                    this.list = res.content.records
                    this.total = res.content.total
                    this.loading = false
                })
            },
           //下一页
            handleCurrentChange(val) {
                console.log(val)
                this.page.current = val
                this.cardList();
            },
             //搜索
            search(){
                this.page.current = 1
                this.cardList();
            },
            //时间范围
            timeSection(e){
                console.log(this.time[0])
                this.page.condition.startDt = this.time[0]+' 00:00:00'
                this.page.condition.endDt = this.time[1]+' 23:59:59'
                console.log(this.page)
            },
            //重置
            reset(){
                this.page.condition.key = null
                this.page.condition.type = null
                this.page.condition.startDt = null
                this.page.condition.endDt = null
                this.page.current = 1
                this.cardList();
            },
            // 修改table header的背景色
            tableHeaderColor({ row, column, rowIndex, columnIndex }){
                if (rowIndex === 0) {
                    return 'background-color: #ECEEF0;color: #606266'
                }
            },
      }
    }
  </script>

<style scoped>
    .cardHead{
        margin-top: 1%;
    }
    .cardA{
        display: inline-block;
        background-color:#FFFFFF;
        width: 20%;
        border-radius: 10px;
        /* margin-left: 2%; */
    }
    .card{
        display: inline-block;
        background-color:#FFFFFF;
        width: 20%;
        border-radius: 10px;
        margin-left: 4%;
    }
    .cardTitle{
        display: inline-block;
        width: 20%;
        /* background-color: aqua; */
    }
    .cardContent{
        display: inline-block;
        width: 70%;
        line-height: 30px;
        /* background-color: blue; */
        vertical-align: middle;
        font-weight: 600;
        text-align: left;
        font-size: 18px;
    }
    .cardImg{
        vertical-align: middle;
        width: 30px;
        height: 30px;
    }
    .cardInput{
        width: 48%;
    }
    .cardP{
        margin-top: 2%;
        line-height: 45px;
        /* background-color: aqua; */
        
    }
    .cardButton{
        margin-top: 2%;
        margin-bottom: 2%;
    }
    .table{
        margin-top: 1%;
        /* height: 75%; */
        width: 92%;
        margin-left: 4%;
        border-radius: 10px;
        background-color: #FFFFFF;
    }
    .tableList{
        width: 96%;
        margin-left: 2%;
    }
    .search{
        display: inline-block;
        width: 65%;
        /* background-color: #5790DF; */
    }

    .tableFiltrate{
        background-color: #FFFFFF;
        padding-top: 1%;
        padding-bottom: 1%;
        border-radius: 10px;
    }
    .customPage{
        margin-top: 1%;
        padding-bottom: 1%;
    }
    .searchInput{
        width: 35%;
        margin-left: 1%
    }
    .title{
        background-color: #FFFF;
        width: 96%;
        line-height: 60px;
        margin-bottom: 0.5%;
        border-radius: 10px;
    }
    .cardSelect{
        width: 98%;
    }
    .inv-h-w{
        background-color: #FFFFFF;
        display: flex;
        margin-top: 1%;
        width: 96%;
        margin-left: 2%;
        /* border-radius: 10px; */
        /* margin-left: 2%; */
        margin-bottom: 1%;
        height: 50px;
        font-size: 18px;
        border-bottom: 2px solid #C4C4C4;
    }
.inv-h{
    /* text-align: center; */
        text-align: left;
        color: #616161;
        line-height: 50px;
        font-weight: 600;
        display: inline-block;
        margin-right: 3%;
        width: 10%;
    }
.inv-h-se{
    text-align: left;
    font-weight: 600;
    color: #000000;
    border-bottom: 4px solid #5BA7FF;
}

    


</style>


// WEBPACK FOOTER //
// src/components/Grant/GrantReceipt/grantReceipt.vue